import React, { useEffect, useMemo, useState } from "react";
// import { Container, Row, Col, CardBody, Card, Button } from "reactstrap";
import { Link } from "react-router-dom";


//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//Import Components
import MiniWidget from "./mini-widget";
import SalesAnalyticsChart from "./salesanalytics-chart";
import TopProduct from "./topselling-product";
import TopUser from "./topuser";
import RecentActivity from "./recent-activity";
import SocialSource from "./socialsource";
import LatestTransaction from "./latest-transaction";
import SimpleBar from "simplebar-react";

//Import Image
import setupanalytics from "../../assets/images/setup-analytics-amico.svg";

import Knob from "../AllCharts/knob/knob"
import moment from 'moment';
import numeral from 'numeral'
import TableContainer from "../../components/Common/TableContainer";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Row, Col, CardBody, Card, FormGroup, Label, Input, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import axios from '../../axios';
import Select from 'react-select'
import './style.css'
import ReactApexChart from "react-apexcharts"
import ApexChart from "./OrderVsShipment";
import BuyerOrderChart from "./BuyerOrder";
import { useCallback } from "react";



// const series1 = [{
//   data: [25, 66, 41, 89, 63, 25, 44, 20, 36, 40, 54]
// }];

// const options1 = {
//   fill: {
//     colors: ['#5b73e8']
//   },
//   chart: {
//     width: 70,
//     sparkline: {
//       enabled: !0
//     }
//   },
//   plotOptions: {
//     bar: {
//       columnWidth: '50%'
//     }
//   },
//   labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
//   xaxis: {
//     crosshairs: {
//       width: 1
//     },
//   },
//   tooltip: {
//     fixed: {
//       enabled: !1
//     },
//     x: {
//       show: !1
//     },
//     y: {
//       title: {
//         formatter: function (seriesName) {
//           return '';
//         }
//       }
//     },
//     marker: {
//       show: !1
//     }
//   }
// };

// const series2 = [70];

// const options2 = {
//   fill: {
//     colors: ['#34c38f']
//   },
//   chart: {
//     sparkline: {
//       enabled: !0
//     }
//   },
//   dataLabels: {
//     enabled: !1
//   },
//   plotOptions: {
//     radialBar: {
//       hollow: {
//         margin: 0,
//         size: '60%'
//       },
//       track: {
//         margin: 0
//       },
//       dataLabels: {
//         show: !1
//       }
//     }
//   }
// };

// const series3 = [55];

// const options3 = {
//   fill: {
//     colors: ['#5b73e8']
//   },
//   chart: {
//     sparkline: {
//       enabled: !0
//     }
//   },
//   dataLabels: {
//     enabled: !1
//   },
//   plotOptions: {
//     radialBar: {
//       hollow: {
//         margin: 0,
//         size: '60%'
//       },
//       track: {
//         margin: 0
//       },
//       dataLabels: {
//         show: !1
//       }
//     }
//   }
// };

// const series4 = [{
//   data: [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]
// }];

// const options4 = {

//   fill: {
//     colors: ['#f1b44c']
//   },
//   chart: {
//     width: 70,
//     sparkline: {
//       enabled: !0
//     }
//   },
//   plotOptions: {
//     bar: {
//       columnWidth: '50%'
//     }
//   },
//   labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
//   xaxis: {
//     crosshairs: {
//       width: 1
//     },
//   },
//   tooltip: {
//     fixed: {
//       enabled: !1
//     },
//     x: {
//       show: !1
//     },
//     y: {
//       title: {
//         formatter: function (seriesName) {
//           return '';
//         }
//       }
//     },
//     marker: {
//       show: !1
//     }
//   }
// };


const Dashboard = () => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const currentMonth = new Date().getMonth() + 1; // Get current month (1-based)
  // console.log(currentMonth,'currentMonth')
  const currentYear = new Date().getFullYear();
  // console.log(currentYear,'currentYear')

  // const reports = [
  //   {
  //     id: 1,
  //     icon: "mdi mdi-arrow-up-bold",
  //     title: "Total Revenue",
  //     value: 34152,
  //     prefix: "$",
  //     suffix: "",
  //     badgeValue: "2.65%",
  //     decimal: 0,
  //     charttype: "bar",
  //     chartheight: 40,
  //     chartwidth: 70,
  //     color: "success",
  //     desc: "since last week",
  //     series: series1,
  //     options: options1,

  //   },
  //   {
  //     id: 2,
  //     icon: "mdi mdi-arrow-down-bold",
  //     title: "Orders",
  //     value: 5643,
  //     decimal: 0,
  //     charttype: "radialBar",
  //     chartheight: 45,
  //     chartwidth: 45,
  //     prefix: "",
  //     suffix: "",
  //     badgeValue: "0.82%",
  //     color: "danger",
  //     desc: "since last week",
  //     series: series2,
  //     options: options2,
  //   },
  //   {
  //     id: 3,
  //     icon: "mdi mdi-arrow-down-bold",
  //     title: "Customers",
  //     value: 45254,
  //     decimal: 0,
  //     prefix: "",
  //     suffix: "",
  //     charttype: "radialBar",
  //     chartheight: 45,
  //     chartwidth: 45,
  //     badgeValue: "6.24%",
  //     color: "danger",
  //     desc: "since last week",
  //     series: series3,
  //     options: options3,
  //   },
  //   {
  //     id: 4,
  //     icon: "mdi mdi-arrow-up-bold",
  //     title: "Growth",
  //     value: 12.58,
  //     decimal: 2,
  //     prefix: "+",
  //     suffix: "%",
  //     charttype: "bar",
  //     chartheight: 40,
  //     chartwidth: 70,
  //     badgeValue: "10.51%",
  //     color: "success",
  //     desc: "since last week",
  //     series: series4,
  //     options: options4,
  //   },
  // ];

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [readonly, setreadonly] = useState(69)
  const [readonly1, setreadonly1] = useState(55)

  //buyerhelp
  const [buyerhelp, setbuyerhelp] = useState([])
  const [buyervalue, setbuyervalue] = useState({ label: "All", value: "and 1=1" })

  //date
  const [fromdate, setfromdate] = useState(new Date())
  const [todate, settodate] = useState(new Date())

  //tabledata
  const [tabledata, settabledata] = useState([])

  const [ftdqty, setftdqty] = useState('')
  const [ftdval, setftdval] = useState('')
  const [mtdqty, setmtdqty] = useState('')
  const [mtdval, setmtdval] = useState('')
  const [ytdqty, setytdqty] = useState('')
  const [ytdval, setytdval] = useState('')

  const [sumValuedata, setsumValuedata] = useState({})
  const [sumQtydata, setsumQtydata] = useState({})

  const [companyId, setcompanyId] = useState(JSON.parse(localStorage.getItem('company')))

  // Years
  const [yearvalue, setyearvalue] = useState({ label: "2025", value: 2025 })

  // Range
  const [periodvalue, setperiodvalue] = useState({ label: "Monthly", value: `${currentMonth}` })

  // Order VS Shipment
  const [ordervsShipmentdata, setordervsShipmentdata] = useState([])
  const [series10, setSeries10] = useState([]);

  // buyer Order Chart
  const [buyerOrderChartdata, setbuyerOrderChartdata] = useState([])
  const [series11, setSeries11] = useState([]);
  const [totalvalue, settotalvalue] = useState('')
  const [qtyinpcs, setqtyinpcs] = useState('')

  const [taskTrackerdata, settaskTrackerdata] = useState([])

  // const handleChange = newValue => {
  //   setvalue(newValue)
  // }
  // const handleChangecursor = newValue => {
  //   setvalue_cur(newValue)
  // }
  // const handleChangeprev = newValue => {
  //   setvalue_prev(newValue)
  // }
  useEffect(() => {
    buyer()
    table()
    // sumOfBuyer()
    // FTD()
    // MTD()
    // YTD()
    GetOrderVSShipmentdata()
    GetBuyerOrderChartdata()
    GetTaskTrackerdata()
    var date = new Date()

    var firstday = new Date(date.getFullYear(), date.getMonth(), 1)

    var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
    console.log(lastday)
    setfromdate(moment(firstday).format('YYYY-MM-DD'))
    settodate(moment(lastday).format('YYYY-MM-DD'))

  }, [todate, fromdate])


  const yearhelp = [
    { "label": "2015", "value": 2015 },
    { "label": "2016", "value": 2016 },
    { "label": "2017", "value": 2017 },
    { "label": "2018", "value": 2018 },
    { "label": "2019", "value": 2019 },
    { "label": "2020", "value": 2020 },
    { "label": "2021", "value": 2021 },
    { "label": "2022", "value": 2022 },
    { "label": "2023", "value": 2023 },
    { "label": "2024", "value": 2024 },
    { "label": "2025", "value": 2025 },
    { "label": "2026", "value": 2026 },
    { "label": "2027", "value": 2027 },
    { "label": "2028", "value": 2028 },
    { "label": "2029", "value": 2029 },
    { "label": "2030", "value": 2030 },
    { "label": "2031", "value": 2031 },
    { "label": "2032", "value": 2032 },
    { "label": "2033", "value": 2033 },
    { "label": "2034", "value": 2034 },
    { "label": "2035", "value": 2035 }
  ]



  //   const periodhelp=[
  //     {label:"Monthly",value:`AND MONTH(OrderDt) = ${currentMonth}`},
  //     {label:"Quarterly",value:'AND DATEPART(QUARTER, OrderDt) = 1'},
  //     {label:"Half-Yearly",value:'AND DATEPART(QUARTER, OrderDt) IN (1, 2)'},
  //     {label:"Annual",value:`AND YEAR(OrderDt) = ${currentYear}`}    
  // ]

  const periodhelp = [
    { label: "Monthly", value: currentMonth },
    { label: "Quarterly", value: 1 },
    { label: "Half-Yearly", value: '(1, 2)' },
    { label: "Annual", value: currentYear }
  ]
  const buyer = async () => {
    await axios.instance.get("/BuyerHelp/BookedBuyerHelp")
      .then((res) => {
        const data = res.data
        const option = data.map(row => ({
          "label": row.buyer,
          "value": row.buyerId
        }))
        console.log(option, "buyerhelp")
        option.push({
          "label": "All",
          "value": "0"
        })
        setbuyerhelp(option)
      })
  }

  const table = async () => {
    // setShowTable(true);
    await axios.instance.get(`/Dashboard?buyerId=${buyervalue.value == 'and 1=1' ? 0 : buyervalue.value}&startDate=${moment(fromdate).format('YYYY-MM-DD')}&endDate=${moment(todate).format('YYYY-MM-DD')}&companyid=${companyId.value}`)
      .then((res) => {
        console.log(res.data, 'table')
        settabledata(res.data)
      })
  };

  const FTD = async () => {
    // setShowTable(true);
    await axios.instance.get(`/Dashboard/GetTodayValue?companyid=${companyId.value}&buyerid=${buyervalue.value}`)
      .then((res) => {
        console.log(res.data, 'table')
        setftdqty(res.data.ftDqty)
        setftdval(res.data.ftDvalue)
      })
  };

  const MTD = async () => {
    // setShowTable(true);
    await axios.instance.get(`/Dashboard/GetMonthValue?companyid=${companyId.value}&buyerid=${buyervalue.value}`)
      .then((res) => {
        console.log(res.data, 'table')
        setmtdqty(res.data.mtDqty)
        setmtdval(res.data.mtDvalue)
      })
  };

  const YTD = async () => {
    // setShowTable(true);
    await axios.instance.get(`/Dashboard/GetYearValue?companyid=${companyId.value}&buyerid=${buyervalue.value}`)
      .then((res) => {
        console.log(res.data, 'table')
        setytdqty(res.data.ytDqty)
        setytdval(res.data.ytDvalue)
      })
  };

  const sumOfBuyer = async () => {
    await axios.instance.get(`/Dashboard/DashboardSumData?companyid=${companyId.value}&buyerid=${buyervalue.value}`)
      .then((res) => {
        console.log(res.data[0].totalValue, 'sumdata')
        setsumValuedata(res.data[0].totalValue)
        setsumQtydata(res.data[0].quantity)
      })
  };



  const column = useMemo(
    () => [
      {
        Header: "Company",
        accessor: (row => (<div className='text-start'>{row.company}</div>)),
        filterable: false,

      },
      {
        Header: "Buyer",
        // accessor:(row=>(<div className='text-start'>{row.buyer}</div>)),
        accessor: 'buyer',
        filterable: false,

      },
      {
        Header: "Ipo No",
        accessor: (row => (<div className='text-end'>{row.ipoNo}</div>)),
        filterable: false,

      },
      {
        Header: "Style",
        accessor: (row => (<div className='text-start'>{row.style}</div>)),
        filterable: false,

      },
      {
        Header: "Order No",
        accessor: (row => (<div className='text-end'>{row.orderNo}</div>)),
        filterable: false,
      },
      {
        Header: "Order Date",
        accessor: (row) => (
          (moment(row.orderDt).format("DD-MM-yyyy"))
        ),
        filterable: false,

      },
      {
        Header: "Rate",
        accessor: (row => (
          <div className='text-end'>{(numeral(row.rate).format('0.00'))}</div>
        )),
        filterable: false,

      },
      {
        Header: "Currency",
        accessor: (row => (<div className='text-start'>{row.curr}</div>)),
        filterable: false,

      },
      {
        Header: "Qty(Pcs)",
        accessor: (row => (<div className='text-end'>{row.qty}</div>)),
        filterable: false,

      },
      {
        Header: " Total Value In INR",
        accessor: (row => (<div className='text-end'>{numeral(row.valueinINR).format("0,0.00")}</div>)),
        filterable: false,

      },
      {
        Header: "Ship Date",
        accessor: (row) => (
          (moment(row.date).format("DD-MM-yyyy"))
        ),
        filterable: false,

      },
      {
        Header: " Ship Mode",
        accessor: (row => (<div className='text-start'>{row.shipMode}</div>)),
        filterable: false,

      },
      {
        Header: "Garment",
        accessor: (row => (<div className='text-start'>{row.garment}</div>)),
        filterable: false,

      },
    ]
  )

  // FTD
  const series1 = [parseInt(ftdqty), parseFloat(ftdval)]
  const options1 = {
    labels: ["FTD Qty", "FTD Value",],
    colors: ["#5b73e8", "#34c38f"],
    legend: {
      show: !0,
      position: 'bottom',
      horizontalAlign: 'center',
      verticalAlign: 'middle',
      floating: !1,
      fontSize: '14px',
      offsetX: 0
    },
    responsive: [{
      breakpoint: 600,
      options: {
        chart: {
          height: 240
        },
        legend: {
          show: !1
        },
      }
    }]
  }

  // MTD
  const series2 = [parseInt(mtdqty), parseFloat(mtdval)]
  const options2 = {
    labels: ["MTD Qty", "MTD Value",],
    colors: ["#f1b44c", "#50a5f1"],
    legend: {
      show: !0,
      position: 'bottom',
      horizontalAlign: 'center',
      verticalAlign: 'middle',
      floating: !1,
      fontSize: '14px',
      offsetX: 0
    },
    responsive: [{
      breakpoint: 600,
      options: {
        chart: {
          height: 240
        },
        legend: {
          show: !1
        },
      }
    }]
  }

  // YTD
  const series3 = [parseInt(ytdqty), parseFloat(ytdval)]
  const options3 = {
    labels: ["YTD Qty", "YTD Value"],
    colors: ["#5b73e8", "#f46a6a"],
    legend: {
      show: !0,
      position: 'bottom',
      horizontalAlign: 'center',
      verticalAlign: 'middle',
      floating: !1,
      fontSize: '14px',
      offsetX: 0
    },
    responsive: [{
      breakpoint: 600,
      options: {
        chart: {
          height: 240
        },
        legend: {
          show: !1,
        },
      }
    }],
  }
  // Order VS Shipment
  // const GetOrderVSShipmentdata = async () => {
  //   // await axios.instance.get(`/Dashboard/GetOrderVSShipmentValue?Wherecond=and  {buyervalue.label=='All'?  1=1: H.BuyerId = 143 }AND YEAR(OrderDt) = 2025 AND DATEPART(QUARTER, OrderDt) = 1`)
  //   await axios.instance.get(`/Dashboard/GetOrderVSShipmentValue?Wherecond=AND ${buyervalue.label === 'All' ? '1=1' : `H.BuyerId = ${buyervalue.value}`} AND YEAR(OrderDt) = ${yearvalue.value} AND DATEPART(QUARTER, OrderDt) = ${periodvalue.value}`)
  //     .then((res) => {
  //       // console.log(res.data[0].totalValue, 'sumdata')
  //       // setsumValuedata(res.data[0].totalValue)
  //       // setsumQtydata(res.data[0].quantity)
  //       console.log(res.data, 'OrderVSShipmentdata')
  //       setordervsShipmentdata(res.data || [])

  //       setSeries10([
  //         {
  //           name: "Orders",
  //           data: months.map(month => res.data?.[0]?.[`${month}Ord`] ?? 0)
  //         },
  //         {
  //           name: "Shipments",
  //           data: months.map(month => res.data?.[0]?.[`${month}Ship`] ?? 0)
  //         },
  //         {
  //           name: "Difference",
  //           data: months.map(month => res.data?.[0]?.[`${month}Diff`] ?? 0)
  //         }
  //       ]);
  //     })
  // };


  const GetOrderVSShipmentdata = async () => {
    try {
      const response = await axios.instance.get(
        `/Dashboard/GetOrderVSShipmentValue?Wherecond=AND ${buyervalue.label === 'All' ? '1=1' : `H.BuyerId = ${buyervalue.value}`} 
      AND YEAR(OrderDt) = ${yearvalue.value} 
      AND DATEPART(QUARTER, OrderDt) = ${periodvalue.value}`
      );

      const data = response.data || [];
      console.log(data, 'OrderVSShipmentdata');

      // Update ordervsShipmentdata first
      setordervsShipmentdata(data);

      // Use functional update for setSeries10
      setSeries10((prevSeries) => {
        if (!data || !data[0]) {
          return prevSeries; // Return previous series if no data or data[0] is not present
        }

        return [
          {
            name: "Orders",
            data: months.map(month => data[0][`${month}Ord`] ?? 0)
          },
          {
            name: "Shipments",
            data: months.map(month => data[0][`${month}Ship`] ?? 0)
          },
          {
            name: "Difference",
            data: months.map(month => data[0][`${month}Diff`] ?? 0)
          }
        ];
      });

    } catch (error) {
      console.error("Error fetching OrderVSShipment data:", error);
    }
  };







  // Buyer Order Chart
  const GetBuyerOrderChartdata = async () => {
    try {
      const buyerCondition = buyervalue.label === 'All' ? '1=1' : `H.BuyerId = ${buyervalue.value}`;
      const response = await axios.instance.get(`/Dashboard/GetBuyerOrderValue?strcond=AND ${buyerCondition} AND YEAR(OrderDt) = ${yearvalue.value} AND DATEPART(QUARTER, OrderDt) = ${periodvalue.value}`);

      console.log(response.data, 'BuyerOrderChartdata');

      if (response.data && response.data.length > 0) {
        setbuyerOrderChartdata(response.data);

        setqtyinpcs(response.data[0].TotalQty);
        settotalvalue(response.data[0].TotalRevenue);
      } else {
        setbuyerOrderChartdata([]);
        setqtyinpcs('');
        settotalvalue('');
      }

    } catch (error) {
      console.error('Error fetching Buyer Order Chart data:', error);
      setbuyerOrderChartdata([]);
      setqtyinpcs('');
      settotalvalue('');
    }
  };

  console.log(buyerOrderChartdata.length, 'BuyerOrderChartdata.length')
  // TaskTracker
  const GetTaskTrackerdata = async () => {
    await axios.instance.get(`/Dashboard/GetTaskTracker?Userid=${localStorage.getItem('UserId')}`)
      .then((res) => {
        console.log(res.data, 'BuyerOrderChartdata')
        settaskTrackerdata(res.data || [])
      })
  };
  const options10 = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 5,
        borderRadiusApplication: 'end'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    },
    yaxis: {
      title: {
        text: ''
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: (val) => ` ${val} `
      }
    }
  };



  // useEffect(() => {
  //   if (ordervsShipmentdata.length > 0) {

  //   }
  // }, [ordervsShipmentdata]);


  //   const series10 = [
  //     {
  //         name: 'Net Profit',
  //         data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
  //     },
  //     {
  //         name: 'Revenue',
  //         data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
  //     },
  //     {
  //         name: 'Free Cash Flow',
  //         data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
  //     }
  // ];



  const [options11, setOptions11] = useState({
    chart: {
      width: 380,
      type: "pie",
    },
    labels: [],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });

  // pie chart
  const emptyOptions = {
    // // ...options11,
    // labels: ["No Data"], // Show "No Data" label in pie chart
    // colors: ["#E0E0E0"] // Light gray color for empty chart
    chart: {
      width: 380,
      type: "pie",
    },
    labels: ["No Data"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  useEffect(() => {
    if (buyerOrderChartdata && buyerOrderChartdata.length > 0) {
      setSeries11(buyerOrderChartdata.map((buyer) => buyer.BuyerRevenue)); // Extract revenue
      setOptions11((prevOptions) => ({
        ...prevOptions,
        labels: buyerOrderChartdata.map((buyer) => `${buyer.Buyer.trim()} 
       
        `), // Extract labels
        // (${buyer.PercentageRevenue}%)
      }));
    }
  }, [buyerOrderChartdata]);
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: 'system-ui' }}>
        <Container fluid>
          <Breadcrumbs title="BMS" breadcrumbItem="Dashboard" />
          <Row>
            <Col>
              <Card style={{ backgroundColor: "white" }}>
                <CardBody>
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex flex-grow-1 justify-content-evenly">
                          <p className="mb-0 fs-5"><strong>Buyer:</strong> <span className="text-dark">{buyervalue.label}</span></p>
                          <p className="mb-0 fs-5"><strong>Year:</strong> <span className="text-dark">{yearvalue.label}</span></p>
                          <p className="mb-0 fs-5"><strong>Range:</strong> <span className="text-dark">{periodvalue.label}</span></p>
                        </div>
                        <Button className="bg-secondary ms-3 fs-5" onClick={toggle}>
                          <i className="uil-filter"></i>
                        </Button>
                      </div>



                      <Modal style={{ backgroundColor: "white" }} isOpen={modal} toggle={toggle} >
                        <ModalHeader toggle={toggle}>Filter</ModalHeader>
                        <ModalBody>
                          <Row>
                            <Col md={12}>
                              <FormGroup>
                                <Label for="buy">
                                  Buyer
                                </Label>
                                <Select
                                  menuPortalTarget={document.body}
                                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                  value={buyervalue}
                                  name="Buyer"
                                  onChange={(value) => {
                                    setbuyervalue(value)
                                  }}
                                  options={buyerhelp}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <FormGroup>
                                <Label for='exbuyer'>
                                  Year
                                </Label>
                                <Select
                                  menuPortalTarget={document.body}
                                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                  value={yearvalue}
                                  name="year"
                                  onChange={(value) => {
                                    setyearvalue(value)
                                    // setperiodtypevalue({ label: "Select", value: "" })
                                    // setperiodvalue({ label: "Select", value: "" })
                                  }}
                                  options={yearhelp}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <FormGroup>
                                <Label for='exbuyer'>
                                  Range
                                </Label>
                                <Select
                                  menuPortalTarget={document.body}
                                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                  value={periodvalue}
                                  name="Buyer"
                                  onChange={(value) => {
                                    setperiodvalue(value)
                                    console.log(value, 'Range Value')
                                    // periodchange(value.value)
                                  }}
                                  options={periodhelp}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </ModalBody>
                        <ModalFooter>
                          <Button color="success" onClick={() => {
                            GetOrderVSShipmentdata();
                            GetBuyerOrderChartdata();
                            GetTaskTrackerdata();
                            table();
                            // sumOfBuyer(); FTD(); MTD(); YTD(); 
                            toggle()

                          }}>
                            Filter
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="4" xs="12" md='4' sm='12'>
              {/* <Card>               
                <CardBody>
                  <ReactApexChart
                    options={options1}
                    series={series1}
                    type="donut"
                    height="320"
                    width={220}
                    className="apex-charts"
                  />
                </CardBody>
                <div className="d-flex justify-content-evenly mb-3">
                  <div>
                    <p className="text-center p-0 m-0"><span style={{ color: '#314fe0', fontWeight: 'bolder' }}>FTD Qty </span></p>
                    <p className="text-center p-0 m-0"><span style={{ fontWeight: 'bolder' }}>{ftdqty}</span></p>
                  </div>
                  <div>
                    <p className="text-center p-0 m-0"><span style={{ color: '#2ade9d', fontWeight: 'bolder' }}>FTD Value </span></p>
                    <p className="text-center p-0 m-0"><span style={{ fontWeight: 'bolder' }}>{numeral(ftdval).format('0,0.00')}</span></p>
                  </div>
                </div>
              </Card> */}
              {/* Order VS Shipment Chart */}
              <Card style={{ backgroundColor: "white" }}>
                <CardBody>
                  <h4 className="card-title mb-4" style={{ color: "#11244c", textAlign: "center" }}><b></b>Order VS Shipment</h4>
                  {/* {series10.length > 0 ?  */}
                  {/* <ApexChart options={options10} series={series10} />  */}
                  <div id="chart">
                    <ReactApexChart
                      key={JSON.stringify(series10)}
                      options={options10}
                      series={series10}
                      type="bar"
                      height={350}
                    />

                  </div>
                  <div id="html-dist"></div>
                  {/* : <p>Loading chart data...</p>} */}
                </CardBody>
              </Card>
            </Col>
            {/* <Col lg="4" xs="12" md='4' sm='12'>
              <Card>              
                <CardBody>
                  <ReactApexChart
                    options={options2}
                    series={series2}
                    type="donut"
                    height="320"
                    width={220}
                    className="apex-charts"
                  />
                </CardBody>
                <div className="d-flex justify-content-evenly mb-3">
                  <div>
                    <p className="text-center p-0 m-0"><span style={{ color: '#f1b44c', fontWeight: 'bolder' }}>MTD Qty </span></p>
                    <p className="text-center p-0 m-0"><span style={{ fontWeight: 'bolder' }}>{mtdqty}</span></p>
                  </div>
                  <div>
                    <p className="text-center p-0 m-0"><span style={{ color: '#50a5f1', fontWeight: 'bolder' }}>MTD Value </span></p>
                    <p className="text-center p-0 m-0"><span style={{ fontWeight: 'bolder' }}>{numeral(mtdval).format('0,0.00')}</span></p>
                  </div>
                </div>
              </Card>
            </Col> */}
            <Col lg="4" xs="12" md='4' sm='12'>
              {/* <Card>
             
                <CardBody>
                  <ReactApexChart
                    options={options3}
                    series={series3}
                    type="donut"
                    height="320"
                    width={220}
                    className="apex-charts"
                  />
                </CardBody>
                <div className="d-flex justify-content-evenly mb-3">
                  <div>
                    <p className="text-center p-0 m-0"><span style={{ color: '#5b73e8', fontWeight: 'bolder' }}>YTD Qty </span></p>
                    <p className="text-center p-0 m-0"><span style={{ fontWeight: 'bolder' }}>{ytdqty}</span></p>
                  </div>
                  <div>
                    <p className="text-center p-0 m-0"><span style={{ color: '#f46a6a', fontWeight: 'bolder' }}>YTD Value </span></p>
                    <p className="text-center p-0 m-0"><span style={{ fontWeight: 'bolder' }}>{numeral(ytdval).format('0,0.00')}</span></p>
                  </div>
                </div>
              </Card> */}
              <Card style={{ backgroundColor: "white" }}>
                <CardBody>
                  <h4 className="card-title mb-4" style={{ color: "#11244c", textAlign: "center" }}><b></b>Book Order</h4>
                  {buyerOrderChartdata.length > 0 ?
                    <BuyerOrderChart options={options11} series={series11} qtyPieces={qtyinpcs} value={totalvalue} type="pie" width={380} />
                    :

                    <BuyerOrderChart options={emptyOptions} series={[1]} qtyPieces={qtyinpcs} value={totalvalue} type="pie" width={380} />
                  }
                </CardBody>
              </Card>
            </Col>
            <Col lg="4" xs="12" md='4' sm='12'>
              <Card style={{ backgroundColor: "white" }}>
                <Row>
                  <Col>
                    <CardBody  >
                      <div className="float-end">
                        {/* <UncontrolledDropdown>
                          <DropdownToggle tag="a" className="text-reset" id="dropdownMenuButton5" caret>
                            <span className="text-muted">Recent<i className="mdi mdi-chevron-down ms-1"></i></span>
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem href="#">Recent</DropdownItem>
                            <DropdownItem href="#">By Users</DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown> */}
                      </div>
                      <h4 className="card-title mb-4" style={{ color: "#11244c", textAlign: "center" }}><b></b>Task Tracker</h4>

                      <SimpleBar className="activity-feed mb-0 ps-2" style={{ maxHeight: '363px' }}>
                        {taskTrackerdata.map((data, index) =>
                          <li className="feed-item" key={index}>
                            <div className="feed-item-list">
                              {/* <p className="text-muted mb-1 font-size-13"><small className="d-inline-block ms-1">{moment(data.DATE).format("DD-MM-YYYY")}</small></p>
                              <p className="mt-0 mb-0">Order For <span>{data.qty}</span> <span>{data.Garment}</span> Under Order Number : <span style={{ color: "#11244c", fontWeight: "bold" }}>{data.OrderNo}</span> & Ipo No : <span style={{ color: "#11244c", fontWeight: "bold" }}>{data.Ipono}</span> <span>{data.descr}</span><span style={{ color: "#11244c", fontWeight: "bold" }}>{data.buyer}</span>
                              </p> */}

                              <p style={{ color: "blue", fontWeight: "bold" }}>Buyer : <span style={{ color: "black", fontWeight: "normal" }}>{data.Buyer}</span></p>
                              <p style={{ color: "blue", fontWeight: "bold" }}>IPO/Style/Order NO : <span style={{ color: "black", fontWeight: "normal" }}>{data.IponoStyle}</span></p>
                              <p style={{ color: "blue", fontWeight: "bold" }}>Task : <span style={{ color: "black", fontWeight: "normal" }}>{data.trackName}</span></p>
                              <p style={{ color: "blue", fontWeight: "bold" }}>Planned Date : <span style={{ color: "black", fontWeight: "normal" }}>{data.PlannedDt}</span></p>
                              <p style={{ color: "blue", fontWeight: "bold" }}>Status :
                                {/* <span style={{ color: "black", fontWeight: "normal" }}>{data.DelayDays}</span> */}
                                {data.DelayDays === 0 ? (
                                  <span style={{ color: "orange", fontWeight: "bold" }}> Due today</span>
                                ) : data.DelayDays > 0 ? (
                                  <span style={{ color: "green", fontWeight: "bold" }}> {data.DelayDays} Day remaining</span>
                                ) : (
                                  <span style={{ color: "red", fontWeight: "bold" }}> Delayed by {Math.abs(data.DelayDays)} Days</span>
                                )}
                              </p>
                              <p style={{ color: "blue", fontWeight: "bold" }}>Current Status: <span style={{ color: "black", fontWeight: "normal" }}>{data.CurrentWIP}</span></p>


                            </div>
                          </li>)}


                      </SimpleBar>
                    </CardBody>
                  </Col>
                </Row>

              </Card>
            </Col>
          </Row>

          {/* <Row>
              <Col lg="6" xs="12" md='6' sm='6'>
                <Card style={{backgroundColor:"white"}}>
                  <CardBody>
                    <div className="text-center" dir="ltr">
                      <Knob
                        value={readonly}
                        angleArc={360}
                        angleOffset={5}
                        fgColor="#11244c"
                        thickness={0.19}
                        readOnly={true}
                        displayInput={false}
                        height={150}
                        width={150}
                        onChange={e => {
                          setreadonly(e)
                        }}
                      />
                    </div>  
                    <div className="text-center" dir="ltr">
                      <h4 className="mb-1 mt-1">
                        <span className="text-nowrap">INR {(numeral(sumValuedata).format('0,0.0000'))}</span>
                      </h4>
                      <p>Total Buyer Value</p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xs="12" md='6' sm='6'>
                <Card style={{backgroundColor:"white"}}>
                  <CardBody>
                    <div>
                      <div className="text-center" dir="ltr">
                        <Knob
                          value={readonly1}
                          fgColor="#11244c"
                          thickness={0.19}
                          readOnly={true}
                          displayInput={false}
                          height={150}
                          width={150}
                          onChange={e => {
                            setreadonly1(e)
                          }}
                        />
                      </div> 
                      <div className="text-center" dir="ltr">
                        <h4 className="mb-1 mt-1">
                          <span>{(numeral(sumQtydata).format('0,0'))}</span>
                        </h4>
                        <p>Total Qty</p>
                      </div> 
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> */}

          <Row>
            <Col lg="12" xs="12" md='12' sm='12'>
              <Card style={{ backgroundColor: "white" }}>
                <CardBody>
                  <Row>
                    <Col>
                      <p className="h5 fw-bold p-2">Shipment Month Wise </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TableContainer
                        columns={column}
                        data={tabledata}
                        // isGlobalFilter={true}
                        //isAddCustomer={true}
                        isAddTableBorderStrap={true}
                      //   handleInvoiceClicks={handleInvoiceClicks}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

          </Row>
        </Container>
      </div>
    </React.Fragment >

  );
};

export default Dashboard;